import { useEffect, useState } from "react";
import closeIcon from "../../Assets/Icons/closeIcon.svg"
import { useForm } from "react-hook-form";
import AuthService from "../../Service.js/authService";
import Select from "../../Components/CommonCommponents/select/Select";
import { Button } from "antd";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";

const Skill = (props) => {
    console.log("test", props.skillDetails);
    const [skills, setSkills] = useState(props.skillDetails.results);
    const [removedSkills, setRemovedSkills] = useState([]);
    const [skillSearch, setSkillSearch] = useState();
    const [skillData, setSkillData] = useState()
    const [newSkills, setNewSkills] = useState([]);

    const {
        register,
        control,
        setValue,
        setError,
        handleSubmit,
        watch,
        reset,
        getValues,
        formState: { errors },
    } = useForm(
        {
            defaultValues: {skills:[]}
        }
    )
    const values = getValues()
    const selectedSkills = watch('skills');

    // useEffect(()=> {
    //     if(values?.skills){
    //         console.log(selectedSkills,"selectedSkills");
    //         console.log(skills,"skills");
    //         const newState = [...selectedSkills]
    //         const newarray1 = newState?.map((item) => {
    //             return(
    //                 {
    //                     id: item.value,
    //                     skills: item.label
    //                 }
                
    //             )
            
    //         })
    //         const testArray = [...skills ,...newarray1]
    //         setSkills(testArray);
    //     }
    // },[props?.isSkillUpdated])


    const removeSkill = async(id) => {
        props?.setSkillUpdate(false)
        console.log("enter remove");
        // const removedSkill = skills.find(item => item?.id === id);
        const updatedSkills = skills.filter(item => item?.id !== id);
        setSkills(updatedSkills);
        // setRemovedSkills(prevState => [...prevState, removedSkill]);
        await CandodateService.createSkills([],[id],[])
            .then(
                (oResponse) => {
                    console.log("oResponse", oResponse);
                    toast.success("Successfully Removed!");
                    props?.setSkillUpdate(true)
                    // props.close()
                    // window.location.reload();
                },
                (error) => {
                    console.log("loginError", error);

                }
            )
            .catch((err) => {
                console.log(err);
                toast.error("Failed To Add")
            });
    };

    const handleSkillSearch = async (value) => {
        console.log("value", value);
        setSkillSearch(value)
        await AuthService.skillsDetails(skillSearch)
            .then(
                (response) => {
                    setSkillData(response.data.data)
                    if (skillData?.results.length === 0) {
                        setNewSkills(prevState => [...prevState, skillSearch]);
                    }
                }
            )
            .catch((error) => {
                console.log(error);
            });
    }
    

    const onChangeQuestionType = (e, onChange) => {
        onChange(e)
        // const newState = [...selectedSkills]
        // console.log("newState",newState)
        // const newarray1 = newState?.map((item) => {
        //     return(
        //         {
        //             id: item.value,
        //             skills: item.label
        //         }
              
        //     )
          
        // })
        // const testArray = [...skills ,...newarray1]
        // setSkills(testArray);
      
       
        // console.log("testnewstate", testArray)
        // console.log("testjobssss", newarray1);
// --------------------------------------------------------


        // newarray1?.map((item) => {

        //     newState.push({
        //         id: item.value,
        //         skills: item.label
        //     })
        // })
        // setSkills(newState);
        // const transformedSkills = selectedSkills?.map((skill, index) => {
        //     return {
        //         id: index + 1, // Generate a unique ID based on the index
        //         skills: skill.label // Use the label property as the skills value
        //     };
        // });

        // setSkills(prevSkills => [...prevSkills, ...transformedSkills]);
        // console.log("skills",skills);
    }
    console.log("testId",removedSkills);

    const onSubmit = async (data) => {
        props?.setSkillUpdate(false)
        const skillId = selectedSkills?.filter((item)=> item?.key !== undefined)?.map(i =>i.value)
        const deletedSkillId = removedSkills?.map(i =>i.id)
        const newAddedSkills = selectedSkills?.filter((item)=> item?.key === undefined)?.map(i =>i.value)
        await CandodateService.createSkills(skillId,deletedSkillId,newAddedSkills)
            .then(
                (oResponse) => {
                    console.log("oResponse", oResponse);
                    toast.success("Successfully Added!");
                    props?.setSkillUpdate(true)
                    props.close()
                    // window.location.reload();
                },
                (error) => {
                    console.log("loginError", error);

                }
            )
            .catch((err) => {
                console.log(err);
                toast.error("Failed To Add")
            });
    }
    console.log("prevState", newSkills);
    console.log("selectedSkills", selectedSkills);
    console.log("skills", skills);
    return (
        <div>
            <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
                <p className="text-base font-semibold mt-10 mb-4">Skills</p>
                <div className="mt-6 mb-4 flex flex-wrap">
                    {skills && skills?.map((item, index) => {
                        return (
                            <div className='rounded-3xl border border-gray-400 p-1 mx-2 px-2 mt-2 bg-[#EFF4F4]'>
                                <div className="flex flex-wrap">
                                    <p className='px-2 text-xs font-normal pt-1'>{item?.skills}</p>
                                    <button type="button" >
                                        <img src={closeIcon} alt="iconclose" onClick={() => removeSkill(item?.id)} />
                                    </button>

                                </div>

                            </div>
                        )
                    })}
                </div>
                <div className=" w-full  mt-6">
                    <Select
                        onSearch={(value) => handleSkillSearch(value)}
                        name="skills"
                        placeholder="Enter your area of Expertise/Specialization"
                        label="Add Skills"
                        control={control}
                        options={skillData?.results?.map((oOption) => {
                            return {
                                value: oOption.option_id,
                                label: oOption.skill,
                            }
                        })}
                        onChange={onChangeQuestionType}
                        mode="tags"
                        showSearch
                        //  options={skillData}
                        rules={{
                            required: 'This field is required'
                        }}
                        addNew={true}
                    // className="h-12"
                    />
                </div>
                <div className="flex flex-wrap justify-end mt-10 ">
                    <Button htmlType="submit" type="submit" className="bg-[#000000] text-white text-base rounded-3xl px-4">Save</Button>
                </div>
                {/* <div>
                <p className="text-base font-semibold mt-10 mb-4">Some Suggested Set of Skills</p>
            </div> */}
            </form>

        </div>
    )
}
export default Skill